import {Injectable, inject} from "@angular/core";
import {IssueContentType, IssueType,} from "@server-models";
import {SharedIssueMessageService} from "@shared/components/issues/services/shared-issue-message.service";
import {SharedIssueMissionService} from "@shared/components/issues/services/shared-issue-mission.service";
import {SharedIssueTicketService} from "@shared/components/issues/services/shared-issue-ticket.service";
import {SharedIssueControlMessageService} from "@shared/components/issues/services/shared-issue-control-message.service";
import {SharedIssueDirectMessageService} from "@shared/components/issues/services/shared-issue-direct-message.service";
import {SharedIssueConnectedService} from "@shared/components/issues/services/shared-issue-connected.service";

@Injectable({
  providedIn: 'root',
})
export class SharedIssueService {
  private _issueMessageService = inject(SharedIssueMessageService);
  private _issueDirectMessageService = inject(SharedIssueDirectMessageService);
  private _issueMissionService = inject(SharedIssueMissionService);
  private _issueTicketService = inject(SharedIssueTicketService);
  private _issueControlMessageService = inject(SharedIssueControlMessageService);
  private _issueConnectedService = inject(SharedIssueConnectedService);


  getIssueFormService(issueType: IssueType | IssueContentType): SharedIssueMessageService | SharedIssueMissionService | SharedIssueTicketService | SharedIssueControlMessageService | SharedIssueConnectedService {
    switch (issueType) {
      case IssueType.Message:
      case IssueContentType.Message:
        return this._issueMessageService;
      case IssueType.DirectMessage:
      case IssueContentType.DirectMessage:
        return this._issueDirectMessageService;
      case IssueType.Mission:
      case IssueContentType.Mission:
        return this._issueMissionService;
      case IssueType.Ticket:
      case IssueContentType.Ticket:
        return this._issueTicketService;
      case IssueType.ControlMessage:
        return this._issueControlMessageService;
      case IssueType.Connected:
        return this._issueConnectedService;
      default:
        throw new Error(`Service, Unsupported issue type: ${ issueType }`);
    }
  }

  getIssueRouteSegment(issueType?: IssueType | IssueContentType): string {
    switch (issueType) {
      case IssueType.Message:
      case IssueContentType.Message:
        return 'message';
      case IssueType.DirectMessage:
      case IssueContentType.DirectMessage:
        return 'direct-message';
      case IssueType.Mission:
      case IssueContentType.Mission:
        return 'mission';
      case IssueType.Ticket:
      case IssueContentType.Ticket:
        return 'ticket';
      case IssueType.ControlMessage:
        return 'control-message';
      case IssueType.Connected:
        return 'connected';
      case IssueType.WinterhalterServiceCall:
      case IssueContentType.WinterhalterServiceCall:
        return 'winterhalter-service-call';
      case IssueType.WinterhalterProductOrder:
      case IssueContentType.WinterhalterProductOrder:
        return 'winterhalter-product-order';
      default:
        return 'message';
    }
  }
}
